// Firebase is loaded on demand, never at module scope.
//
// A static `import { initializeApp } from 'firebase/app'` here put firebase-vendor
// (~42 kB) on the eager first-paint path for every user, because this module is
// reached from the push hooks mounted in MainLayout. Push is opt-in and only
// matters after the user grants notification permission, so nothing about
// firebase needs to exist before first paint.
//
// `import type` below is erased at compile time and does NOT pull firebase in.
import type { FirebaseApp } from 'firebase/app';
import type { Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyCM_DzZxvVHjvLnnlXS1sbGAJd6fE-_4KA',
  authDomain: 'rabex-8b993.firebaseapp.com',
  projectId: 'rabex-8b993',
  storageBucket: 'rabex-8b993.firebasestorage.app',
  messagingSenderId: '14455350706',
  appId: '1:14455350706:web:0de3d04828890d010f70ab'
};

// Memoised so repeated calls reuse one app instance and one network fetch.
let appPromise: Promise<FirebaseApp> | null = null;

export function getFirebaseApp(): Promise<FirebaseApp> {
  if (!appPromise) {
    appPromise = import('firebase/app').then(({ initializeApp }) =>
      initializeApp(firebaseConfig)
    );
  }
  return appPromise;
}

export async function getMessagingInstance(): Promise<Messaging | null> {
  const { getMessaging, isSupported } = await import('firebase/messaging');
  const supported = await isSupported(); // guards Safari/older browsers
  if (!supported) return null;
  return getMessaging(await getFirebaseApp());
}
